import { useMutation } from '@tanstack/react-query';
import { signOut } from 'firebase/auth';

import { auth, deleteJWTCookie, deleteSpaceCookie } from '@/utils/firebase-helpers';

async function logoutFromFirebaseInstance() {
  const firebaseAuth = await auth();

  // Sign out from Firebase
  await signOut(firebaseAuth);

  // Delete the JWT cookie using centralized helper
  deleteJWTCookie();

  // Delete the space preference cookie so the next user
  // gets fresh detection based on their own claims
  deleteSpaceCookie();
}

export function useLogoutMutation() {
  return useMutation({
    mutationFn: logoutFromFirebaseInstance,
  });
}
